import { createContext, useContext } from "react";
export const ClientProductContext = createContext(null);
export const useClientProductId = () => {
  return useContext(ClientProductContext);
};